import React, {useState, useRef} from 'react';
import './App.css';
import ToDoListTemplete from './component/ToDoListTemplete';
import ToDoItemList from './component/ToDoItemList';
import Form from './component/Form';

const colors = ['#343a40','#f03e3e','#12b886','#228ae6'];

function App() {
  const [input, setInput] = useState('');
  const [todos, setTodos] = useState([
    {id:0, text:'리액트 실습하기', checked:true},
    {id:1, text:'todolist', checked:false},
    {id:2, text: '상태관리하기', checked:true}
  ]);

  const [color, setColor] = useState('#343a40');
  const nextid = useRef(3);

  const handleChange = (e) => {
    setInput(e.target.value);
  }

  const handleCreate = () => {
    if(!input.trim()) return;

    const newTodo = {
      id:nextid.current,
      text:input,
      checked:false,
      color:color
    }

    setTodos(todos.concat(newTodo)); //기존 목록 뒤에 추가
    setInput('');
    nextid.current+=1;
  }

  const handleKeyPress = (e) => {
    if(e.key === 'Enter') {
      handleCreate();
    }
  }

  const handleToggle = (id) => {
    setTodos(
      todos.map((todo)=>todo.id == id ? {...todo, checked:!todo.checked}:todo)
    )
  }

  const onRemove = (id) => {
    setTodos(todos.filter((todo)=> todo.id !== id));
  }

  return (
    <>
    <ToDoListTemplete form={<Form value={input} onKeyPress={handleKeyPress} onChange={handleChange} onCreate={handleCreate} color={color}/>}>
      <ToDoItemList todos={todos} onToggle={handleToggle} onRemove={onRemove}/>
    </ToDoListTemplete>
    </>
  );
}

export default App;
